<template>
  <BaseCard>
    <BaseCardBody>
      <SectionHeader title="SMS Campaign Setting" description="Update SMS campaign settings." />
    </BaseCardBody>
    <BaseCardBody>
      <SmsCampaignForm
        :account-id="smsCampaign.account_id"
        :default-data="smsCampaign"
        :from-options="fromOptions"
        :action="update"
        :disabled="!canEdit"
      />
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import SmsCampaignForm from '@/components/SmsCampaign/SmsCampaignForm.vue';
import { accountThirdPartyServicesClient, smsCampaignsClient } from '@/api/clients';
import SectionHeader from './SectionHeader.vue';

export default {
  components: {
    SectionHeader,
    SmsCampaignForm,
  },
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fromOptions: [],
    };
  },
  computed: {
    canEdit() {
      return ['DRAFT', 'CANCELLED', 'FAILED'].indexOf(this.smsCampaign.status) >= 0;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      return accountThirdPartyServicesClient
        .list(this.smsCampaign.account_id, {
          params: {
            filter: {
              channel: 'sms',
              active: true,
            },
          },
        })
        .then((thirdPartyServicesResponse) => {
          this.fromOptions = (thirdPartyServicesResponse?.data?.data || []).map(
            (thirdPartyService) => ({
              value: thirdPartyService.id,
              label: thirdPartyService?.config?.name || thirdPartyService.id,
            })
          );

          return Promise.resolve();
        });
    },
    update(data) {
      return smsCampaignsClient.update(this.smsCampaign.id, data);
    },
  },
};
</script>
